import './StreamingDots.scss'

const StreamingDots = () => (
    <div className="streaming-dots">
        <span /><span /><span />
    </div>
)

export default StreamingDots
